// material ui
import { Card, CardContent, Divider, Typography } from '@mui/material';

// relative
import AlarmTypeCardHeader from '../../AlarmTypeCardHeader';

const InsufficientData = ({ alarm }) => {
  return (
    <Card>
      <AlarmTypeCardHeader alarm={alarm} title="Seep Leakage Detected" />
      <Divider />
      <CardContent>
        <Typography variant="body1">{alarm.Details}</Typography>
      </CardContent>
    </Card>
  );
};

export default InsufficientData;
